import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import type { DateRange } from '@packages/fenrir/components/date-pickers';

import type { FormData } from '../approved-login-locations-form-values';

export const useApprovedLoginLocationsValidation = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    country: yup
      .string()
      .required(t('components:alertConfigurationRules:singleCountryRequired')),
    duration: yup
      .mixed<[string | undefined, string | undefined]>()
      .test('is-valid', t('error:datePicker.invalidDateRange'), (range) => {
        const [start, end]: DateRange<Dayjs> = [
          range?.at(0) ? dayjs(range.at(0)) : null,
          range?.at(1) ? dayjs(range.at(1)) : null,
        ];

        return range && (!start || start.isValid()) && (!end || end.isValid());
      })
      .test(
        'is-start-before-end',
        t('formValidation:startShouldBeBeforeEnd', {
          start: t('ui:date.startDate'),
          end: t('ui:date.endDate'),
        }),
        (range) => {
          const [start, end]: DateRange<Dayjs> = [
            range?.at(0) ? dayjs(range.at(0)) : null,
            range?.at(1) ? dayjs(range.at(1)) : null,
          ];

          return !start || !end || start.isBefore(end);
        },
      ),
  }) as yup.ObjectSchema<FormData>;
};
